import { getApiClient } from './ApiClient'

export const achievementListPromise = (params) => {
  return getApiClient()
    .get('/achievements', { params })
    .then(resp => resp.data)
}

export const userAchievementListPromise = (page, size, userId) => {
  const params = { page, size }
  if (userId) params.userId = userId

  return getApiClient()
    .get('/user-achievement-list', {
      params: params,
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}